import create from 'zustand/vanilla';
import createHook from 'zustand';
import { emptyObject } from '@constants/empty';

export const calendarStore = create((set) => ({
  calendarCurrentDate: emptyObject,
  setCurrentDate: (dateInMs, goalUID) =>
    set((state) => ({
      ...state,
      calendarCurrentDate: { ...state.calendarCurrentDate, [goalUID]: dateInMs }
    }))
}));

export const calendarStoreV2 = create((set) => ({
  calendarCurrentDate: null,
  setCurrentDate: (dateInMs) =>
    set((state) => ({
      ...state,
      calendarCurrentDate: dateInMs
    }))
}));

const useCalendarStore = createHook(calendarStore);
export const useCalendarStoreV2 = createHook(calendarStoreV2);

export default useCalendarStore;
